import { fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';

export async function getSellerData(
  sellerId: string,
  getSellerProducts: boolean,
) {
  return fetchWrapper(
    endpoint +
      `/v1/amazon-keepa/seller/${sellerId}?get_seller_products=${
        getSellerProducts ? '1' : '0'
      }`,
  ).then((res) => res.json());
}

export async function getProductData(asin: string) {
  return fetchWrapper(
    endpoint + '/v1/amazon-keepa/product/' + asin,
  ).then((res) => res.json());
}
